import React from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';

import './Footer.css';

const Footer = function () {
  const { t, i18n } = useTranslation('translation');

  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng);
  };

  return (
    <footer className="site-footer text-align__center container">
      <div className="row footer-content">
        <div className="col slogan">{t('footer.SLOGAN')}</div>
        <div className="col">
          <picture>
            <source srcSet="/assets/images/logo-footer.png 2x" />
            <img
              className="logo logo__footer"
              src="/assets/images/logo-footer.png"
              alt="Avonova logotyp"
            />
          </picture>
        </div>
        <button
          onClick={() => {
            changeLanguage('sv');
          }}
          className="language-selector"
        >
          <img src="/assets/images/se.png" alt="svenska flaggan" />
        </button>
        <button
          onClick={() => {
            changeLanguage('en');
          }}
          className="language-selector"
        >
          <img src="/assets/images/en.png" alt="engelska flaggan" />
        </button>
      </div>
    </footer>
  );
};

export default connect()(Footer);
